<template>
  <div class="hello">
    <div class="name">啦啦啦啦</div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$myWidth: 75;
.name{
  font-size: 18px;
  height: 98rem/$myWidth
}

</style>
